import { render, staticRenderFns } from "./demo.vue?vue&type=template&id=3c2e43f9&scoped=true"
import script from "./demo.vue?vue&type=script&lang=js"
export * from "./demo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e43f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2e43f9')) {
      api.createRecord('3c2e43f9', component.options)
    } else {
      api.reload('3c2e43f9', component.options)
    }
    module.hot.accept("./demo.vue?vue&type=template&id=3c2e43f9&scoped=true", function () {
      api.rerender('3c2e43f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/organization/demo.vue"
export default component.exports